import Env from "../base/env";
import { CardHoverBase, TextHoverSlide } from "./Common";
import gsap from "gsap";

export default () => ({
  closeSearch() {
    Env.$html.classList.remove("search-opened");
    document.getElementById("predictive-search").style.display = "none";
    gsap.delayedCall(0.6, () => {
      document.getElementById("form-search").reset();
    });
  },
  openSearch() {
    Env.$html.classList.add("search-opened");
    document.getElementById("Search").select();
  },
  hideGiftAlert() {
    Env.$html.classList.remove("gift-alert-opened");
  },
  showGiftAlert() {
    Env.$html.classList.add("gift-alert-opened");
  },
  hideStockAlert() {
    Env.$html.classList.remove("stock-alert-opened");
  },
  showStockAlert() {
    Env.$html.classList.add("stock-alert-opened");
  },
  cardItemBase(item) {
    CardHoverBase(item);
  },
  textHoverSlide(item) {
    TextHoverSlide(item);
  },
});
